// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"1":"student","328":"admin","756":"professor"}[chunkId] || chunkId) + "." + {"1":"649513bc","64":"57e48ea7","328":"28fa5264","756":"15e2ec8c"}[chunkId] + ".js";
};